@if (clientsService.loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (clients.length > 0 && !clientsService.loading) {
  <div class="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1" role="none">
    <app-clients-sidebar class="file-manager-sidebar" [ngClass]="isSidebarVisible ? 'menubar-show' : ''" id="menusidebar" [clients]="clients" (showSidebarEvent)="toggleSidebar($event)"></app-clients-sidebar>
    <div class="file-manager-content w-100 p-3 py-0">
      <router-outlet></router-outlet>
    </div>
  </div>
}
@if (clients.length === 0 && !clientsService.loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <div class="text-center">
      <h1 class="text-warning">No Clients has been found!</h1>
      <p class="text-muted">Contact your administrator to check this issue.</p>
    </div>
  </div>
}